import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Iframe, OpenNewpage, VideoContainer } from './style';
import storage from '../../../app/api/storage';
import { parseQueryParams } from '../../../utils/queryParams';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import { CTA, Icon, Text } from '../../atoms';
import { apiHost } from '../../../app/api/config';

const VideoScorm = ({ mediaIsPhone, selectedActivity, handleOnCompleted }) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) handleOnCompleted();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getScormUrl = () => {
    const params = {
      paragraph_scorm_id: selectedActivity?.id,
      token: storage.read('Auth')?.value?.token,
    };
    const url = `${selectedActivity?.data.scorm_url}${parseQueryParams(
      params
    )}`;

    return url;
  };

  const openFullscreen = () => {
    window.open(getScormUrl(), '_blank');
  };

  if (mediaIsPhone) {
    return (
      <VideoContainer>
        <OpenNewpage onClick={openFullscreen}>
          <Text type="b5" mb={16}>
            {selectedActivity?.title}
          </Text>
          <Icon type="play-circle" size={33} />
        </OpenNewpage>
      </VideoContainer>
    );
  }

  return (
    <>
      <div className="mb-4">
        <CTA
          onClick={() => window.open(getScormUrl(), '_blank')}
          btnText="VISUALIZZA IN UNA NUOVA PAGINA"
        />
      </div>
      <VideoContainer>
        <Iframe
          title={selectedActivity?.title}
          src={getScormUrl()}
          id="scorm_frame"
          allowFullscreen={`fullscreen ${apiHost}`}
          webkitallowfullscreen={`fullscreen ${apiHost}`}
          mozallowfullscreen={`fullscreen ${apiHost}`}
          msallowfullscreen={`fullscreen ${apiHost}`}
          oallowfullscreen={`fullscreen ${apiHost}`}
          allow={`fullscreen ${apiHost}`}
        />
      </VideoContainer>
    </>
  );
};

VideoScorm.propTypes = {
  mediaIsPhone: PropTypes.bool,
  selectedActivity: PropTypes.object.isRequired,
  handleOnCompleted: PropTypes.func,
};

export default withMediaQueries(VideoScorm);
